import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { FaBullhorn, FaChevronRight } from 'react-icons/fa';
import { ClassroomContext } from '../../context/ClassroomContext';
import NotificationContext from '../../context/NotificationContext';
import ClassroomAssignments from './ClassroomAssignments';
import styles from './styles/ClassroomDashboard.module.css';


const ClassroomDashboard = () => {
    const { classroom } = useContext(ClassroomContext);
    const { getUnseenAnnouncementCount } = useContext(NotificationContext);

    // Read-ness comes from the notification feed, not the announcement list:
    // announcements have no per-user state of their own.
    const unreadCount = getUnseenAnnouncementCount(classroom?._id);
    const announcementsPath = `/my-classrooms/${classroom?._id}/a`;

    return (
        <div className={styles.dashboardContainer}>
            <section className={styles.announcementsSection}>
                <h3 className={styles.sectionTitle}>Announcements</h3>
                <Link
                    to={announcementsPath}
                    className={`${styles.announcementsStatus} ${unreadCount > 0 ? styles.hasUnread : ''}`}
                >
                    <span className={styles.statusIcon}>
                        <FaBullhorn />
                        {unreadCount > 0 && <span className={styles.unreadDot} />}
                    </span>
                    <span className={styles.statusText}>
                        {unreadCount > 0
                            ? `${unreadCount} new announcement${unreadCount === 1 ? '' : 's'}`
                            : "You're all caught up"}
                    </span>
                    <span className={styles.statusAction}>
                        {unreadCount > 0 ? 'View announcements' : 'View older announcements'}
                        <FaChevronRight />
                    </span>
                </Link>
            </section>

            <section className={styles.assignmentsSection}>
                <h3 className={styles.sectionTitle}>Assignments</h3>
                <ClassroomAssignments fromDashboard={true} />
            </section>
        </div>
    );
};

export default ClassroomDashboard;
